import { post } from '../Services/http';
import { catchError } from './Error.action';

let abortController;

export const download = (articleNumber) => (dispatch) => {
    return post('/api/datasheet/getfile', articleNumber, abortController )
    .then(response => {
        if (response.ok) return response.blob()
        throw new Error('Failed to download file ')
    })
    .then(blob => {
        var file = window.URL.createObjectURL(blob);
        var fileName = "datasheet_" + articleNumber + ".pdf";
        const anchor = document.createElement("a");
        anchor.href = file
        anchor.download = fileName

        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)

        window.URL.revokeObjectURL(file)
    })
    .catch((ex) => dispatch(catchError(ex, (error) => console.log(error))));
};